<div class="card-message-file">
  <mat-list class="card-message-file-list">
    <img class="card-message-file-imageIcon" [src]="fileType" />
    <div class="card-message-file-name">{{ fileName }}</div>
  </mat-list>
</div>
